import WOW from 'wowjs';
import Slider from "react-slick";
import React, { useEffect, useState } from 'react';
import { LiveKitRoom, RoomAudioRenderer, BarVisualizer, useVoiceAssistant, VoiceAssistantControlBar } from "@livekit/components-react";

import './index.css';
import 'animate.css';
import '../../static/css/animate.css';
import Navbar from '../../components/navbar';

// const address = 'Coming Soon';
const chain = 'bsc';
const address = '0xd9A5bD3826206022c8f0B046B3CCcee97B84CbEb';

const Home = () => {
    const [agentState, setAgentState] = useState("connected");
    const [connectionDetails, setConnectionDetails] = useState(null);
    const [voiceState, setVoiceState] = useState('idle');

    const handleConnect = async () => {
        try {
            const response = await fetch("https://server.doge-ai.fun/api/connection_details");
            if (!response.ok) {
                throw new Error("Failed to fetch connection details");
            }
            const data = await response.json();
            setConnectionDetails(data);
            setAgentState("connected");
            // setIsVisible(true);
            console.log("Connection details fetched:", data);
        } catch (error) {
            // setError(error.message);
            console.error("Failed to fetch connection details:", error);
        }
    };

    // Handle Disconnect
    const handleDisconnect = () => {
        console.log("Disconnected");
        setConnectionDetails(null);
        setAgentState("disconnected");
    };

    const handleVoiceAgentStateChange = (newState) => {
        setVoiceState(newState);
    };

    useEffect(() => { new WOW.WOW({ live: true }).init() }, []);

    const marqueSetting = {
        dots: false,
        infinite: true,
        slidesToShow: 6,
        slidesToScroll: 1,
        autoplay: true,
        speed: 9000,
        autoplaySpeed: 0,
        cssEase: 'linear',
        arrows: false,
        rtl: true,
    };

    const storiesSettings = {
        dots: false,
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        initialSlide: 0,
        autoplay: true,
        autoplaySpeed: 3000,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    initialSlide: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };

    return (
        <div className='doge-ai-page'>
            <div>
                <Navbar />
                {/* Banner */}
                <section className="banner-section" id="home">
                    <div className="auto-container">
                        <div className="row">
                            <div className="col-6">
                                <div className='content-left-area text-center'>
                                    <div className='left-text-area'>
                                        {/* <h4>welcome to</h4> */}
                                        <h1><img src={require("../../static/images/main-title.png")} alt="" /></h1>
                                        <p><i>Ready for some tasty</i><br /> <span>roasts</span> and <span> crypto wisdom</span>?</p>
                                    </div>
                                    <div className='right-text-area'>
                                        <div className='sound-wayes'>
                                            <img className='top-arrows' src={require("../../static/images/top-arows.png")} alt="" />
                                            <button className='talk-btn' onClick={handleConnect}>
                                                <img src={require("../../static/images/talk-btn.png")} alt="" />
                                            </button>
                                            <h5 className='click'>Click Here</h5>
                                            {connectionDetails && (
                                                <>

                                                    <LiveKitRoom
                                                        token={connectionDetails.participantToken}
                                                        serverUrl={connectionDetails.serverUrl}
                                                        connect={agentState !== 'disconnected'}
                                                        audio={true}
                                                        video={false}
                                                        onDisconnected={handleDisconnect}
                                                        className="grid grid-rows-[2fr_1fr] items-center"
                                                    >
                                                        <SimpleVoiceAssistant handleVoiceAgentStateChange={handleVoiceAgentStateChange} />
                                                        <VoiceAssistantControlBar controls={{ leave: false }} />
                                                        <RoomAudioRenderer />
                                                    </LiveKitRoom>

                                                    <button className='disconnect-btn' style={{ color: 'white' }} onClick={handleDisconnect}>
                                                        X
                                                    </button>
                                                </>
                                            )}
                                        </div>

                                    </div>
                                </div>
                                <div className='right-social-area'>
                                    <ul>
                                        <li><a href="https://t.me/TalktoDogeAI" target="_blank" className='social-link'><img src={require("../../static/images/telegram.png")} alt="" /></a></li>
                                        <li><a href="https://x.com/TalktoDogeAI" target="_blank" className='social-link'><img src={require("../../static/images/twitter.png")} alt="" /></a></li>
                                        <li><a href={`https://dexscreener.com/${chain}/${address}`} target="_blank" className='social-link'><img src={require("../../static/images/dex.png")} alt="" /></a></li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-6">
                                <div className='content-area text-center'>
                                    <div className='left-img wow fadeIn'>
                                        <img src={require("../../static/images/banner-img.png")} alt="" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <div className='bottom-marquee-area'>
                    <div className="horizontal-scrolling-items">
                        <Slider {...marqueSetting} className='wow fadeInLeft'>
                            <div className="horizontal-scrolling-items__item">
                                $DogeAI
                            </div>
                            <div className="horizontal-scrolling-items__item">
                                $DogeAI
                            </div>
                            <div className="horizontal-scrolling-items__item">
                                $DogeAI
                            </div>
                            <div className="horizontal-scrolling-items__item">
                                $DogeAI
                            </div>
                            <div className="horizontal-scrolling-items__item">
                                $DogeAI
                            </div>
                            <div className="horizontal-scrolling-items__item">
                                $DogeAI
                            </div>
                            <div className="horizontal-scrolling-items__item">
                                $DogeAI
                            </div>
                            <div className="horizontal-scrolling-items__item">
                                $DogeAI
                            </div>
                        </Slider>
                    </div>
                </div>

                {/* About Section */}
                <section className='about-sec' id="about">
                    <div className='auto-container'>
                        <div className='row'>
                            <div className='col-lg-5 col-md-5 col-sm-12'>
                                <div className='left-text-area  wow fadeIn'>
                                    <div className='sec-title text-center'>
                                        <h2>about</h2>
                                    </div>
                                    <div className='text-box'>
                                        <p>Much wow, I’m Doge AI—the playful, roast-master crypto companion you never knew you needed! From market dips to meme coin madness, I’m here to help you learn, laugh, and maybe stop chasing that next pump. Let’s make crypto fun (and less confusing), fren!</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <div className='bottom-marquee-area style-two'>
                    <div className="horizontal-scrolling-items">
                        <Slider {...marqueSetting} className='wow fadeInLeft'>
                            <div className="horizontal-scrolling-items__item">
                                $DogeAI
                            </div>
                            <div className="horizontal-scrolling-items__item">
                                $DogeAI
                            </div>
                            <div className="horizontal-scrolling-items__item">
                                $DogeAI
                            </div>
                            <div className="horizontal-scrolling-items__item">
                                $DogeAI
                            </div>
                            <div className="horizontal-scrolling-items__item">
                                $DogeAI
                            </div>
                            <div className="horizontal-scrolling-items__item">
                                $DogeAI
                            </div>
                            <div className="horizontal-scrolling-items__item">
                                $DogeAI
                            </div>
                            <div className="horizontal-scrolling-items__item">
                                $DogeAI
                            </div>
                        </Slider>
                    </div>
                </div>

                {/* Tokenomics Section */}
                <section className='tokenomics-sec' id="tokenomics">
                    <div className='auto-container'>
                        <div className='row'>
                            <div className='col-12'>
                                <div className='sec-title text-center'>
                                    <h2>Tokenomics</h2>
                                </div>
                            </div>
                            <div className='col-lg-3 col-md-6 col-sm-6'>
                                <div className='tokenomics-box'>
                                    <div className='tokenomics-img'>
                                        <img src={require("../../static/images/tokenomics-1.png")} alt="" />
                                    </div>
                                    <div className='text-box'>
                                        <h4>token address</h4>
                                        <p>{address}</p>
                                    </div>
                                </div>
                            </div><div className='col-lg-3 col-md-6 col-sm-6'>
                                <div className='tokenomics-box'>
                                    <div className='tokenomics-img'>
                                        <img src={require("../../static/images/tokenomics-2.png")} alt="" />
                                    </div>
                                    <div className='text-box'>
                                        <h4>100% lp burnt</h4>
                                    </div>
                                </div>
                            </div>
                            <div className='col-lg-3 col-md-6 col-sm-6'>
                                <div className='tokenomics-box'>
                                    <div className='tokenomics-img'>
                                        <img src={require("../../static/images/tokenomics-3.png")} alt="" />
                                    </div>
                                    <div className='text-box'>
                                        <h4>total supply</h4>
                                        {/* <p>1000000000</p> */}
                                    </div>
                                </div>
                            </div>
                            <div className='col-lg-3 col-md-6 col-sm-6'>
                                <div className='tokenomics-box'>
                                    <div className='tokenomics-img'>
                                        <img src={require("../../static/images/tokenomics-4.png")} alt="" />
                                    </div>
                                    <div className='text-box'>
                                        <h4>mint  authority<br />revoked</h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <div className='bottom-marquee-area style-two'>
                    <div className="horizontal-scrolling-items">
                        <Slider {...marqueSetting} className='wow fadeInLeft'>
                            <div className="horizontal-scrolling-items__item">
                                $DogeAI
                            </div>
                            <div className="horizontal-scrolling-items__item">
                                $DogeAI
                            </div>
                            <div className="horizontal-scrolling-items__item">
                                $DogeAI
                            </div>
                            <div className="horizontal-scrolling-items__item">
                                $DogeAI
                            </div>
                            <div className="horizontal-scrolling-items__item">
                                $DogeAI
                            </div>
                            <div className="horizontal-scrolling-items__item">
                                $DogeAI
                            </div>
                            <div className="horizontal-scrolling-items__item">
                                $DogeAI
                            </div>
                            <div className="horizontal-scrolling-items__item">
                                $DogeAI
                            </div>
                        </Slider>
                    </div>
                </div>

                {/* features Section */}
                <section className='features-sec' id="features">
                    <div className='auto-container'>
                        <div className='row'>
                            <div className='col-lg-6 col-md-6 col-sm-12'>
                                <div className='sec-title text-center'>
                                    <h2>features</h2>
                                </div>
                                <div className='much-text'>
                                    {/* <h3>Much Strategy</h3>
                                    <h3 className='wihte-text'>very wisdom</h3> */}
                                    <img src={require("../../static/images/much-text.png")} alt="" />
                                    <ul>
                                        <li>Crypto Mentorship</li>
                                        <li>Market Insights & Risk Management</li>
                                        <li>AI-Powered Trading Advice</li>
                                    </ul>
                                </div>

                            </div>
                            <div className='col-lg-6 col-md-6 col-sm-12'>
                                <div className='features-right-box'>
                                    <div className='features-img'>
                                        <img src={require("../../static/images/feature-right-img.png")} alt="" />
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <div className='bottom-marquee-area style-two'>
                    <div className="horizontal-scrolling-items">
                        <Slider {...marqueSetting} className='wow fadeInLeft'>
                            <div className="horizontal-scrolling-items__item">
                                $DogeAI
                            </div>
                            <div className="horizontal-scrolling-items__item">
                                $DogeAI
                            </div>
                            <div className="horizontal-scrolling-items__item">
                                $DogeAI
                            </div>
                            <div className="horizontal-scrolling-items__item">
                                $DogeAI
                            </div>
                            <div className="horizontal-scrolling-items__item">
                                $DogeAI
                            </div>
                            <div className="horizontal-scrolling-items__item">
                                $DogeAI
                            </div>
                            <div className="horizontal-scrolling-items__item">
                                $DogeAI
                            </div>
                            <div className="horizontal-scrolling-items__item">
                                $DogeAI
                            </div>
                        </Slider>
                    </div>
                </div>

                {/* Tokenomics Section */}
                <section className='story-sec' id="story">
                    <div className='auto-container'>
                        <div className='row'>
                            <div className='col-12'>
                                <div className='sec-title text-center'>
                                    <h2>stories</h2>
                                </div>
                                <Slider {...storiesSettings} className='wow fadeInLeft'>
                                    <div>
                                        <div className='story-box'>
                                            <div className='story-img'>
                                                <img src={require("../../static/images/story-img-bg.png")} alt="" />
                                                <div className='overlay-box'>
                                                    <img src={require("../../static/images/story-img-1.jpg")} alt="" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div className='story-box'>
                                            <div className='story-img'>
                                                <img src={require("../../static/images/story-img-bg.png")} alt="" />
                                                <div className='overlay-box'>
                                                    <img src={require("../../static/images/story-img-2.jpg")} alt="" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div className='story-box'>
                                            <div className='story-img'>
                                                <img src={require("../../static/images/story-img-bg.png")} alt="" />
                                                <div className='overlay-box'>
                                                    <img src={require("../../static/images/story-img-3.jpg")} alt="" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div className='story-box'>
                                            <div className='story-img'>
                                                <img src={require("../../static/images/story-img-bg.png")} alt="" />
                                                <div className='overlay-box'>
                                                    <img src={require("../../static/images/story-img-4.jpg")} alt="" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div className='story-box'>
                                            <div className='story-img'>
                                                <img src={require("../../static/images/story-img-bg.png")} alt="" />
                                                <div className='overlay-box'>
                                                    <img src={require("../../static/images/story-img-5.jpg")} alt="" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div className='story-box'>
                                            <div className='story-img'>
                                                <img src={require("../../static/images/story-img-bg.png")} alt="" />
                                                <div className='overlay-box'>
                                                    <img src={require("../../static/images/story-img-6.jpg")} alt="" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div className='story-box'>
                                            <div className='story-img'>
                                                <img src={require("../../static/images/story-img-bg.png")} alt="" />
                                                <div className='overlay-box'>
                                                    <img src={require("../../static/images/story-img-7.jpg")} alt="" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div className='story-box'>
                                            <div className='story-img'>
                                                <img src={require("../../static/images/story-img-bg.png")} alt="" />
                                                <div className='overlay-box'>
                                                    <img src={require("../../static/images/story-img-8.jpg")} alt="" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div className='story-box'>
                                            <div className='story-img'>
                                                <img src={require("../../static/images/story-img-bg.png")} alt="" />
                                                <div className='overlay-box'>
                                                    <img src={require("../../static/images/story-img-9.jpg")} alt="" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div className='story-box'>
                                            <div className='story-img'>
                                                <img src={require("../../static/images/story-img-bg.png")} alt="" />
                                                <div className='overlay-box'>
                                                    <img src={require("../../static/images/story-img-10.jpg")} alt="" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Slider>
                            </div>

                        </div>
                    </div>
                </section>

                <div className='bottom-marquee-area style-two'>
                    <div className="horizontal-scrolling-items">
                        <Slider {...marqueSetting} className='wow fadeInLeft'>
                            <div className="horizontal-scrolling-items__item">
                                $DogeAI
                            </div>
                            <div className="horizontal-scrolling-items__item">
                                $DogeAI
                            </div>
                            <div className="horizontal-scrolling-items__item">
                                $DogeAI
                            </div>
                            <div className="horizontal-scrolling-items__item">
                                $DogeAI
                            </div>
                            <div className="horizontal-scrolling-items__item">
                                $DogeAI
                            </div>
                            <div className="horizontal-scrolling-items__item">
                                $DogeAI
                            </div>
                            <div className="horizontal-scrolling-items__item">
                                $DogeAI
                            </div>
                            <div className="horizontal-scrolling-items__item">
                                $DogeAI
                            </div>
                        </Slider>
                    </div>
                </div>

                {/* Community Section */}
                <section className='community-sec' id="community">
                    <div className='auto-container'>
                        <div className='row'>
                            <div className='col-6'>
                            </div>
                            <div className='col-6'>
                                <div className='title-area'>
                                    <h3>Join</h3>
                                    <h2>Doge Army!</h2>
                                    <h4> Much Bark, Very Loud!</h4>
                                </div>

                                <div className='bottom-social-area'>
                                    <ul>
                                        <li><a href="https://t.me/TalktoDogeAI" target="_blank" className='social-link'><span><img src={require("../../static/images/telegram.png")} alt="" /></span> telegram</a></li>
                                        <li><a href="https://x.com/TalktoDogeAI" target="_blank" className='social-link'><span><img src={require("../../static/images/twitter.png")} alt="" /></span> twitter</a></li>
                                        <li><a href={`https://dexscreener.com/${chain}/${address}`} target="_blank" className='social-link'><span><img src={require("../../static/images/dex.png")} alt="" /></span> DexScreener</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>


            {/* Enter Website */}
            {/* <Modal open={isEnterModal} onClose={() => setIsEnterModal(false)} className='modal-enter-website'>
                <div className='body-modal'>
                    <div className='modal-inner'>
                        <div className='left-text-area'>
                            <h1>TRON </h1>
                            <h2>DOG</h2>
                        </div>
                        {isPageLoaded
                            ? <button className='entry-btn' onClick={() => handleEnterWebsite()}>Start</button>
                            : <i className="loader"><img src={require('../../static/images/spinner.gif')} alt='' /></i>
                        }
                    </div>
                </div>
            </Modal> */}
        </div >
    );
}

export default Home;


function SimpleVoiceAssistant({ handleVoiceAgentStateChange }) {
    const { state, audioTrack } = useVoiceAssistant();

    useEffect(() => {
        handleVoiceAgentStateChange(state);
    }, [state, handleVoiceAgentStateChange]);

    return (
        <>
            <div className="h-80">
                <BarVisualizer state={state} trackRef={audioTrack} className='bar-custom' />
                <p className="text-center">{ }</p>
            </div>
        </>
    );
}